import { Cell, flexRender, Row } from "react-table-8.10.7";
import { ChatQnAResponse } from "types/Models/chatQnA";
import { ArrayElement } from "types/utils/ArrayElement";

type RequestedAnswer = ArrayElement<ChatQnAResponse["requested_answers"]>;

type MobileRequestAnswerRowProps = {
  row: Row<RequestedAnswer>;
  isSubmitted: boolean;
};

// Column ids set on the column helpers in RequestAnswersTable.
const REQUEST_ANSWER_COLUMN_ID = {
  QUESTION: "question",
  ANSWER: "answer",
  DOCUMENTS: "documents",
} as const;

const renderCell = (cell?: Cell<RequestedAnswer, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileRequestAnswerRow = ({
  row,
  isSubmitted,
}: MobileRequestAnswerRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );
  const documentsCell = cellsById[REQUEST_ANSWER_COLUMN_ID.DOCUMENTS];
  const documentsLabel = isSubmitted
    ? "Documents"
    : "Upload documents (if any)";

  return (
    <div className="t-flex t-flex-col t-gap-3 t-rounded-lg t-border t-border-solid t-border-neutral-0 t-p-3">
      {renderCell(cellsById[REQUEST_ANSWER_COLUMN_ID.QUESTION])}
      <div className="t-min-w-0">
        {renderCell(cellsById[REQUEST_ANSWER_COLUMN_ID.ANSWER])}
      </div>
      {documentsCell && (
        <div className="t-flex t-flex-col t-gap-1">
          <span className="t-text-body-sm t-text-text-30">
            {documentsLabel}
          </span>
          {renderCell(documentsCell)}
        </div>
      )}
    </div>
  );
};
